<template>
  <div class="transform-child-component-main">
      <div class="pbc-component-type-header">
        <div class="pbc-component-type-icon-parent">
          <repeat :size='16' class="pbc-component-type-icon" />
        </div>
        <div class="pbc-component-type-name">spawner</div>
      </div>

      <div class="transform-child-component-summary">
        <div class="transform-child-component-text">After</div>

        <display-or-edit v-model='transform.vars.initialDelay' type='number' label="secs" :variables='variables' />

        <div class="transform-child-component-text">create every</div>
        <display-or-edit v-model='transform.vars.firetime' type='number' label="secs" :variables='variables' />
      </div>


    </div>
</template>
<script>
import DisplayOrEdit from '@ui/atoms/DisplayOrEdit.vue';
import Check from '@icons/Check.vue';
import Repeat from '@icons/Repeat.vue';
import GameVariables from '@edit/tree/gamevariables.js';
export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    parentTransform:{
      type:Object,
      required:true
    },
    transformsAndSource:{
      type:Object,
      required:true
    }
  },
  data() {
    console.log('LOL', this.transform);
    const gamevariables = new GameVariables(this.transformsAndSource.gamedata);
    const variables = gamevariables.getVariablesForTransform(this.transformsAndSource, this.transform);

    return {
      value:10,
      editingInitialDelay: false,
      editingRepeat: false,
      variables
    }
  },
  components:{
    Repeat,
    DisplayOrEdit
    //Check
  },
  computed:{
    textClasses() {
      return ['m-auto','mx-2','text-gray-400']
    },
    inputClasses() {
      return "w-8 flex-1 my-1 bg-blue-700 text-white appearance-none border-2 border-blue-900 rounded px-2 leading-tight focus:outline-none focus:bg-blue-400 focus:border-purple-500";
    }
  }
}
</script>
